import { CONFIG } from "../helper/config";

export const viewActions = {
    ACTIVE_LOADER: 'ACTIVE_LOADER',
    SET_THEME: 'SET_THEME',
    LICENSE_EXPIRE:'LICENSE_EXPIRE',
    UNREGISTERED_USER:'UNREGISTERED_USER',
    STORE_SESSION_ID:'STORE_SESSION_ID'
};

/*
set activeLoader state to true/false to show/hide loader 
*/
export const activeLoader = (active_loader: boolean, loading_time: number = CONFIG.LOADING_TIME) => (dispatch: (arg0: any) => void) => {
    dispatch({
        type: viewActions.ACTIVE_LOADER,
        payload: { active_loader, loading_time },
    });
};

/*
set theme state to store 
*/
export const setTheme = (new_theme: string) => (dispatch: (arg0: { type: string; payload: { theme: string } }) => void) => {
    dispatch({
        type: viewActions.SET_THEME,
        payload: { theme: new_theme },
    });
};


/**
 * Sets the license expiration flag in the store.
 * 
 * @param {boolean} is_license_expire - Indicates whether the license is expired.
 * Dispatches an action to update the license expiration state in the store.
 */

export const setLicenseExpireFlag = (is_license_expire : boolean) => (dispatch:(arg0: any)=> void) => {
    dispatch({
      type: viewActions.LICENSE_EXPIRE,
      payload: {is_license_expire},
    });
  };

/**
 * Set the flag and message for unregistered user
 * @param {boolean} is_demo - true if user is demo user, false if not
 * @param {string} msg - message to be displayed for unregistered user
 */
  export const setUnregisterdUserMessage = (is_demo : boolean, msg: string) => (dispatch:(arg0: any)=> void) => {
    dispatch({
      type: viewActions.UNREGISTERED_USER,
      payload: {is_demo, msg},
    });
  };

/**
 * Store the session id in the store
 * @param {string} sessionId - Session id which will be stored in the store
 */
  export const storeSessionId = (sessionId:string) => (dispatch:(arg0: any)=> void) => {
    dispatch({
      type: viewActions.STORE_SESSION_ID,
      payload: {sessionId},
    });
  };